export default __webpack_public_path__ + "static/media/promo-you-know-who_01.41429971.jpg";